module.exports = __webpack_public_path__ + "static/media/training-icon-active.8063b999.svg";